import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e0a43c1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ue-border-form-item"
};
const _hoisted_2 = {
  class: "label"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]), _renderSlot(_ctx.$slots, "field", {}, undefined, true)]);
}